"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Suggestion = void 0;
const resource_model_1 = require("./resource.model");
/**
 * A suggestion made to appear as value to select.
 */
class Suggestion extends resource_model_1.Resource {
    load(x) {
        super.load(x);
        this.value = x.value;
        this.name = this.clean(x.name, String);
        this.description = this.clean(x.description, String);
        this.category1 = this.clean(x.category1, String);
        this.category2 = this.clean(x.category2, String);
    }
    /**
     * Clear the suggestion.
     */
    clear() {
        this.value = null;
        this.name = null;
        this.description = null;
        this.category1 = null;
        this.category2 = null;
    }
}
exports.Suggestion = Suggestion;
